import { ApiHelper } from '../helpers/api.helper';
import { UserHelper } from '../helpers/user.helper';
import { IUser } from '../types/user.type';
import { IUserForm } from '../views/Profile/components/UserForm/types';

const PATH = 'user';

export const fetchUser = async (): Promise<IUser> => {
  const response = await fetch(ApiHelper.makeUrl(PATH), ApiHelper.makeOptions());
  const data = await response.json();

  if (!response.ok) {
    ApiHelper.handleError(data);
  }

  return data?.data;
};

export const updateUser = async (params: IUserForm): Promise<IUser> => {
  const body = UserHelper.createFormData(params);

  const response = await fetch(ApiHelper.makeUrl(PATH), {
    method: 'POST',
    body,
    ...ApiHelper.makeOptions(false),
  });

  const data = await response.json();

  if (!response.ok) {
    ApiHelper.handleError(data);
  }

  return data?.data;
};

export const removeCv = async (version: string): Promise<IUser> => {
  const response = await fetch(ApiHelper.makeUrl(`${PATH}/cv?version=${version}`), {
    method: 'DELETE',
    ...ApiHelper.makeOptions(false),
  });

  const data = await response.json();

  if (!response.ok) {
    ApiHelper.handleError(data);
  }

  return data?.data;
};

export const uploadPhoto = async (picture: File): Promise<IUser> => {
  const formData = new FormData();
  formData.append('picture', picture);

  const response = await fetch(ApiHelper.makeUrl(`${PATH}/photo`), {
    method: 'POST',
    body: formData,
    ...ApiHelper.makeOptions(false),
  });

  const data = await response.json();

  if (!response.ok) {
    ApiHelper.handleError(data);
  }

  return data?.data;
};
